<div class="coupon-card card mr-auto ml-auto ml-md-0" [ngClass]="couponDisplayFormat === 'grid' ? 'mw-100' : ''" role="region" attr.aria-label="{{cardProps?.cardAriaLabel}}">
    <div class="coupon-card__card-body">
        <div aria-live="polite" class="sr-only" #couponStatus></div>
        <div class="coupon-card__card-body__card-title">
            <div *ngIf="cardType === 'coupon'">

                <div *ngIf="cardProps?.iconImage && cardProps?.iconImage !== ''">
                    <ng-container *ngIf="!isForULogoRebrandingDisabled && cardProps?.iconImage === forULogoIconImage; else oldOfferCardForulogo">
                        <span class="icon pds-svg-foru-vertical-theme-tm-primary_medium_24" role="img" aria-label="For U Logo"></span>
                    </ng-container>
                    <ng-template #oldOfferCardForulogo>
                        <img *ngIf="logoProps && logoProps[cardProps?.iconImage]"
                            src="{{logoProps[cardProps?.iconImage]?.logo}}"
                            class="svg-icon just-for-you-16px icon-position" 
                            alt='{{logoProps[cardProps?.iconImage]?.altText}}' attr.aria-label='{{logoProps[cardProps?.iconImage]?.altText}} {{cardProps?.cardHeader}}'>
                          
                    </ng-template>

                    </div>
            </div>
            <div class="coupon-card__card-body__card-title__price">
                {{cardProps?.cardHeader}}
            </div>
        </div>
        <div class="row cpn-details font-weight-bold ml-4 pl-1 pb-1 text-truncate" id="coupon-price-{{_cardData?.offerId}}" *ngIf="_cardData?.regularPrice && couponDisplayFormat === 'grid'" [ngClass]="{'in-store-price-visible' : _cardData?.regularPrice && _cardData?.regularPrice !== ''}">In-store: ${{_cardData?.regularPrice}}</div>

        <div class="row">
            <div class="col-8">
                <h3 class="cpn-title mb-0" [ngClass]="couponDisplayFormat === 'grid' ? 'd-block text-truncate' : ''">{{cardProps?.cardTitle}}</h3>
                <div class="cpn-details">
                    {{cardProps?.cardDescription}}
                </div>
                <div class="coupon-card-offer-details-container">
                    <a class="coupon-card-offer-details offer-details" 
                       id="cardOfferDetails_{{_cardData?.offerId}}" 
                       [href]="getOfferDetailsHref()"
                       [attr.aria-label]="cardProps?.cardHeader + ' offer details'"
                       (click)="onClickOfDetails('offer-detail', $event)" 
                       (keyup.enter)="onClickOfDetails('offer-detail', $event)" 
                       role="link">{{cardProps?.cardLinkText}}</a>
                </div>
            </div>
            <div class="col-4" [innerHTML]="cardProps?.cardImage" role="img" [attr.aria-label]="cardProps?.cardTitle || couponImage"></div>
        </div>
        <div class="cpn-flex-area d-flex w-100" [ngClass]="couponDisplayFormat === 'grid' ? 'flex-nowrap' : ''">
            <div class="w-50">
                <loyalty-card-action-buttons [cardType]="cardType" [data]="_cardData" (emitClippedCoupon)="clipCoupon($event)"></loyalty-card-action-buttons>
            </div>
            <div class="w-50 coupon-expiry">
                <div class="d-flex flex-column" [innerHTML]="cardProps?.cardExpirySection" style="right: 16px; position: absolute;" role="contentinfo"></div>
            </div>
        </div>
    </div>
</div>
